import { render, staticRenderFns } from "./orderSettle.vue?vue&type=template&id=208b6e4e&scoped=true"
import script from "./orderSettle.vue?vue&type=script&lang=js"
export * from "./orderSettle.vue?vue&type=script&lang=js"
import style0 from "./orderSettle.vue?vue&type=style&index=0&id=208b6e4e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208b6e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208b6e4e')) {
      api.createRecord('208b6e4e', component.options)
    } else {
      api.reload('208b6e4e', component.options)
    }
    module.hot.accept("./orderSettle.vue?vue&type=template&id=208b6e4e&scoped=true", function () {
      api.rerender('208b6e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderSettle.vue"
export default component.exports